import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'
import { ConfigCompanyDetails } from '../CompanyDetails/types'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

const config = ({ countries, formType }: ConfigCompanyDetails & {formType?: string}) => utils.injectTranslation({
  id: 'CompanyStatusForm',
  path: 'onboarding.forms.CorporateAccount.CompanyStatusForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'companyRegulatedStatus',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'companyRegulatedStatus1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'companyRegulatedStatus2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(3, 0.32fr)',
        marginLeft: '4%',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'nameOfFinancialRegulator',
            removeLabelEllipsis: true,
            required: true,
            maxlength: 100,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'regulatorAuthorisationNumber',
            removeLabelEllipsis: true,
            required: true,
            maxlength: 100,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'countryOfRegulator',
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'countryOfRegulator',
            label: 'onboarding.forms.CorporateAccount.CompanyStatusForm.inputs.countryOfRegulator.label',
            placeholder: 'onboarding.forms.CorporateAccount.CompanyStatusForm.inputs.countryOfRegulator.placeholder',
            required: true,
            filter: true,
            ...props
          })
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        marginLeft: '4%',
      },
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'regulatorPaymentInstitutionType',
            dataList: [
              {
                id: 'regulatorPaymentInstitutionType1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'regulatorPaymentInstitutionType2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isCompanyListed',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'companyListedStatus1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'companyListedStatus2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(3, 0.32fr)',
        marginLeft: '4%',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'listedStockExchangeName',
            removeLabelEllipsis: true,
            required: true,
            maxlength: formType === 'Deliverable' ? 100 : 250,
          },
          secondaryName: 'isCompanyListed-listedStockExchangeName'
        },
        {
          componentType: 'input',
          props: {
            name: 'listingCodeNumber',
            removeLabelEllipsis: true,
            required: true,
            maxlength: formType === 'Deliverable' ? 100 : 250,
          },
          secondaryName: 'isCompanyListed-listingCodeNumber'
        },
        {
          componentType: 'input',
          props: {
            name: 'countryOfListedStockExchange',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'countryOfListedStockExchange',
            label: 'onboarding.forms.CorporateAccount.CompanyStatusForm.inputs.countryOfListedStockExchange.label',
            placeholder: 'onboarding.forms.CorporateAccount.CompanyStatusForm.inputs.countryOfListedStockExchange.placeholder',
            required: true,
            filter: true,
            ...props
          }),
          secondaryName: 'isCompanyListed-countryOfListedStockExchange'
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        marginLeft: '4%',
      },
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isUBOCompanyListed',
            dataList: [
              {
                id: 'regulatorPaymentInstitutionType1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'regulatorPaymentInstitutionType2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(3, 0.32fr)',
        marginLeft: '4%',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'listedStockExchangeName',
            removeLabelEllipsis: true,
            required: true,
            maxlength: formType === 'Deliverable' ? 100 : 250,
          },
          secondaryName: 'isUBOCompanyListed-listedStockExchangeName'
        },
        {
          componentType: 'input',
          props: {
            name: 'listingCodeNumber',
            removeLabelEllipsis: true,
            required: true,
            maxlength: formType === 'Deliverable' ? 100 : 250,
          },
          secondaryName: 'isUBOCompanyListed-listingCodeNumber'
        },
        {
          componentType: 'input',
          props: {
            name: 'countryOfListedStockExchange',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'countryOfListedStockExchange',
            label: 'onboarding.forms.CorporateAccount.CompanyStatusForm.inputs.countryOfListedStockExchange.label',
            placeholder: 'onboarding.forms.CorporateAccount.CompanyStatusForm.inputs.countryOfListedStockExchange.placeholder',
            required: true,
            filter: true,
            ...props
          }),
          secondaryName: 'isUBOCompanyListed-countryOfListedStockExchange'
        },
      ],
    },
  ],
})

export default config
